import { PickerMap } from '@/types';

const IMAGE_ACCEPT_MAP: PickerMap = {
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'image/heic': ['.heic'],
  'image/heif': ['.heif']
};

const VIDEO_ACCEPT_MAP: PickerMap = {
  'video/mp4': ['.mp4', '.m4v'],
  'video/ogg': ['.ogg', '.ogv']
};

const AUDIO_ACCEPT_MAP: PickerMap = {
  'audio/mpeg': ['.mp3'],
  'audio/mp4': ['.m3a', '.m4a'],
  'audio/x-m4a': ['.m4a'],
  'audio/ogg': ['.oga']
};

const IMAGE_VIDEO_ACCEPT_MAP: PickerMap = {
  ...IMAGE_ACCEPT_MAP,
  ...VIDEO_ACCEPT_MAP
};

const MEDIA_ACCEPT_MAP: PickerMap = {
  ...VIDEO_ACCEPT_MAP,
  ...AUDIO_ACCEPT_MAP,
  ...IMAGE_ACCEPT_MAP
};

export const DEFAULT_THUMBNAIL_EXTENSION = '.jpeg';

export const UPLOAD_PICKER_TYPES = {
  IMAGE: [
    {
      description: 'Image Files',
      accept: IMAGE_ACCEPT_MAP
    }
  ],

  VIDEO: [
    {
      description: 'Video Files',
      accept: VIDEO_ACCEPT_MAP
    }
  ],

  AUDIO: [
    {
      description: 'Audio Files',
      accept: AUDIO_ACCEPT_MAP
    }
  ],

  BACKGROUND: [
    {
      description: 'Background Media Files',
      accept: IMAGE_VIDEO_ACCEPT_MAP
    }
  ],

  IMAGE_VIDEO: [
    {
      description: 'Image and Video Files',
      accept: IMAGE_VIDEO_ACCEPT_MAP
    }
  ],

  MEDIA: [
    {
      description: 'All Media Files',
      accept: MEDIA_ACCEPT_MAP
    },
    {
      description: 'Video Files',
      accept: VIDEO_ACCEPT_MAP
    },
    {
      description: 'Audio Files',
      accept: AUDIO_ACCEPT_MAP
    },
    {
      description: 'Image Files',
      accept: IMAGE_ACCEPT_MAP
    }
  ]
};
